import R from 'app/assets/R'
import { IResponseImportFile, StatusEnum } from './type'
import { convertedVariables } from 'app/styles/themes/themeVariables'

export const DefineStatusEnum = {
  [StatusEnum.DUPLICATED]: {
    text: R.strings.duplicated_treatment,
    color: convertedVariables.statesRedColor,
  },
  [StatusEnum.WRONG_DISCOUNT_TYPE]: {
    text: R.strings.wrong_discount_type,
    color: convertedVariables.statesRedColor,
  },
  [StatusEnum.WRONG_DISCOUNT_INPUT]: {
    text: R.strings.wrong_discount_input,
    color: convertedVariables.statesRedColor,
  },
  [StatusEnum.NOT_FOUND_TREATMENT]: {
    text: R.strings.not_found_treatment,
    color: convertedVariables.statesRedColor,
  },
  [StatusEnum.SUCCESS]: {
    text: R.strings.success,
    color: convertedVariables.statesGreenColor,
  },
}

export const InitResponseImport: IResponseImportFile = {
  insert: [],
  modify: [],
  remove: [],
}

export enum TabKey {
  UPDATE = '1',
  INSERT = '2',
  REMOVE = '3',
}
